// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedKeratoscopyClFitting_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 5.99609C15.4075 5.99609 18.7329 7.38355 22.1791 9.99609H18.6059C16.2905 8.6399 14.1222 7.99609 12 7.99609C9.87782 7.99609 7.70943 8.6399 5.39405 9.99609H1.8209C5.26711 7.38355 8.59251 5.99609 12 5.99609Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8744 17.9961C20.2548 17.2773 19.5412 16.6341 18.7505 16.0846C16.5586 17.3406 14.3613 17.9961 12.1279 17.9961C9.8492 17.9961 7.60813 17.3138 5.37194 16.0074C4.53628 16.5736 3.78433 17.2434 3.13549 17.9961H0.627197C3.02619 14.3878 7.22553 11.9961 12.005 11.9961C16.7844 11.9961 20.9837 14.3878 23.3827 17.9961H20.8744ZM12.005 13.9961C13.6634 13.9961 15.232 14.3291 16.6467 14.9265C15.0981 15.6492 13.6012 15.9961 12.1279 15.9961C10.6182 15.9961 9.08364 15.6319 7.4941 14.8722C8.87443 14.3089 10.3975 13.9961 12.005 13.9961Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedKeratoscopyClFitting is a generated icon component.
 */
let IconMedKeratoscopyClFitting = IconMedKeratoscopyClFitting_1 = class IconMedKeratoscopyClFitting extends IconBaseElement {
    render() {
        return html `${IconMedKeratoscopyClFitting_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedKeratoscopyClFitting.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedKeratoscopyClFitting = IconMedKeratoscopyClFitting_1 = __decorate([
    customElement('zui-icon-med-keratoscopy-cl-fitting')
], IconMedKeratoscopyClFitting);
export { IconMedKeratoscopyClFitting };
